import React from 'react';
import {FieldError} from 'react-hook-form';
import classnames from 'classnames';
import {getErrorMessage} from 'helpers/utils';

interface TextInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: FieldError | FieldError[];
  className?: string;
  containerClassName?: string;
}

export const TextInput = React.forwardRef<HTMLInputElement, TextInputProps>((props, ref) => {
  const {id, type = 'text', className, containerClassName, label, error, required, ...inputProps} = props;
  const errorMessage = error ? getErrorMessage(error, label) : null;

  return (
    <div className={classnames('text-input-wrapper', containerClassName)}>
      {label && (
        <label htmlFor={id}>
          {label} {required && <span>*</span>}
        </label>
      )}
      <input
        id={id}
        ref={ref}
        className={classnames(errorMessage ? 'text-input--error' : 'text-input', className)}
        autoComplete="on"
        type={type}
        {...inputProps}
      />
      {errorMessage && <p className="input-error-message">{errorMessage}</p>}
    </div>
  );
});
